{
  "cpq.cpq-user-feedback.question.no-translate": [
    {
      "type": 0,
      "value": "What is your feedback?"
    }
  ],
  "cpq.cpq-user-feedback.statement.no-translate": [
    {
      "type": 0,
      "value": "What is your feedback?"
    }
  ]
}